import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const PageHeader = ({ title, breadcrumbs = [] }) => {
  return (
    <div
      className="relative overflow-hidden py-12"
      style={{
        background: 'linear-gradient(135deg, #1c2a1f 0%, #2d3a2e 60%, #2d3a2e 100%)',
      }}
    >
      {/* Decorative circles */}
      <div
        className="absolute -top-10 -right-10 w-52 h-52 rounded-full opacity-10"
        style={{ background: '#43a047' }}
      />
      <div
        className="absolute bottom-0 left-1/4 w-32 h-32 rounded-full opacity-5"
        style={{ background: '#43a047' }}
      />

      <div className="relative max-w-6xl mx-auto px-4">
        {/* Breadcrumb */}
        <nav className="anim-fade-in flex items-center gap-1.5 text-xs mb-3">
          <Link to="/" className="flex items-center gap-1 text-green-300 hover:text-white">
            <Home size={12} />
            Home
          </Link>
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              <ChevronRight size={11} className="text-green-700" />
              {crumb.href ? (
                <Link to={crumb.href} className="text-green-300 hover:text-white">{crumb.label}</Link>
              ) : (
                <span className="text-green-400">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>

        {/* Title */}
        <h1 className="anim-slide-right text-3xl md:text-4xl font-bold text-white leading-tight">
          {title}
        </h1>
        {/* Green accent line */}
        <div
          className="anim-fade-in delay-300 mt-3 h-1 w-14 rounded-full"
          style={{ background: '#43a047' }}
        />
      </div>
    </div>
  );
};

export default PageHeader;
